import React, { useState } from 'react'

import img from 'assets/images/distributionPage/Privilage/4.png'
import classNames from 'classnames'
import { useDistributionContext } from 'pages/Distribution/Distribution'
import AnimateHeight from 'react-animate-height'
import { AnimatedForm, Button, Form } from 'shared/components'
import { useWindowSize } from 'shared/hooks'
import { detectDevice } from 'shared/utils/detectDevice'

import { DistributionFirstBlockBackground } from './Background/Background'
import { DistributionCalculator } from './Calculator/Calculator'
import classes from './FirstBlock.module.scss'
import { fields } from './form'
import { MobileDistributionBackground } from './MobileBackground/MobileBackground'
import { FormTypes } from 'models'

export const distributionFirstBlockId = 'distributionFirstBlock'

export const DistributionFirstBlock = (): JSX.Element => {
  const parentID = 'distributionFirstBlock'
  const formId = 'distribution-partners-form'
  const { isPartnerFormOpened, setPartnerFormOpened } = useDistributionContext()

  const [isSubmit, setIsSubmit] = useState(false)
  const { isMobile } = useWindowSize()
  const isTabletDevice = detectDevice()

  const handleSubmit = () => {
    setIsSubmit(true)
  }

  const handleClose = () => {
    setIsSubmit(false)
    setPartnerFormOpened(false)
  }

  const containerClass = classNames([
    classes.section_title,
    'col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6',
    {
      [classes.offset]: isTabletDevice,
      [classes.section__earn]: isMobile,
    },
  ])
  const calculatorContainer = classNames([
    'col-xs-12 col-sm-6 col-md-6 col-lg-offset-1 col-lg-5 col-xl-5',
    {
      'reveal-from-bottom-medium': isMobile,
    },
  ])
  return (
    <div className={classes.wrapper} id={distributionFirstBlockId}>
      <div className={`${classes.container} container`}>
        <AnimateHeight
          duration={400}
          height={!isPartnerFormOpened ? 'auto' : 0}
        >
          <div className={`${classes.row} row`}>
            <div className={containerClass}>
              <h1 className="mb-2 title">ЗАРАБАТЫВАЙ С{'\n'}УДОВОЛЬСТВИЕМ!</h1>
              <span className="color-secondary">
                Получай вознаграждение за каждого активного подписчика.{'\n'}
                Продавай продукты онлайн-кинотеатра KION и получай{'\n'}
                дополнительный доход
              </span>
              <div className="mb-1 mt-1">
                <Button onClick={() => setPartnerFormOpened(true)}>
                  Стать партнером
                </Button>
              </div>
              {(isTabletDevice || isMobile) && (
                <img className={classes.tabletImg} src={img} alt="" />
              )}
            </div>
            <div
              className={`${classes.section_calculator} ${calculatorContainer}`}
            >
              <DistributionCalculator />
            </div>
          </div>
        </AnimateHeight>

        <AnimatedForm
          id={formId}
          duration={400}
          open={isPartnerFormOpened}
          onCloseClick={() => handleClose()}
          scrollToElement={false}
          scrollCenter={isSubmit}
        >
          <Form
            showed={isPartnerFormOpened}
            id={formId}
            fields={fields}
            title="Стать партнером"
            formClasses={classes.form}
            showUserAgreement
            onCloseClick={() => handleClose()}
            onAutoClose={() => handleClose()}
            onSubmit={() => handleSubmit()}
            type={FormTypes.Distributive}
            dark
            titleLarge
          />
        </AnimatedForm>
      </div>
      {isTabletDevice || isMobile ? (
        <MobileDistributionBackground />
      ) : (
        <DistributionFirstBlockBackground parentID={parentID} />
      )}
    </div>
  )
}
